import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import { Component, MouseEventHandler } from "react";
import {
  Alert,
  Badge,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  NavLink,
  Spinner,
} from "reactstrap";
import React from "react";
import { BAN, SortBAN } from "../../store/Interfaces";
import {
  faCarCrash,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnyAction } from "redux";
import { relative } from "path";
import MediaQuery from 'react-responsive'



const fileAlt = <FontAwesomeIcon className="ml-2" icon={faFileAlt} />;
let interval = setInterval(() => { }, 10000);
class BillingSearchGrid extends Component<{
  bans: BAN[], btnDropright: boolean[], actions: {
    customerbillsActions: AnyAction;
  }
}> {
  getBill(ban: string, nobills: boolean | undefined, indexofban: number): MouseEventHandler<HTMLElement> | undefined {

    // if (nobills && localStorage.getItem("accessToken") ) {
    if (nobills) {
      // this.setState({
      //   isLoading: true,
      // });

      fetch(
        process.env.REACT_APP_API_HOST +
        `/CABSBill/GetBillsByBAN?ban=` + ban,
        {
          method: "GET",
          // credentials: "include",
          headers: {
            pragma: "no-cache",
            "cache-control": "no-cache",
            'Authorization': 'Bearer ' + localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          },

        }
      )
        .then(r => r.json().then(data => ({ status: r.status, body: data })))
        .then((thedata) => {

          if (thedata.status === 200) {
            let newBans: BAN[] = this.state.bans;
            if (newBans[indexofban] !== undefined) {
              newBans[indexofban] = thedata.body as BAN;
              newBans[indexofban].ban = ban;
            }
            let newerrorlist = this.state.errorlist;
            newerrorlist[indexofban] = undefined;

            this.setState({
              bans: newBans,
              isLoading: false,
              errorlist: newerrorlist
            })
          } else {
            this.catchError("Status returned: " + thedata.status, indexofban, ban);
          }
        })

        .catch((error) => {
          this.catchError(error, indexofban, ban);

        });
    }
    return undefined;
  }


  public catchError(error: any, indexofban: number, ban: string) {
    let newBans: BAN[] = this.state.bans;
    newBans[indexofban].ban = ban;
    newBans[indexofban].bills = [];

    let newerrorlist = this.state.errorlist;
    newerrorlist[indexofban] = "There was a problem loading the bills for " + this.state.bans[indexofban].ban;

    this.setState({
      bans: newBans,
      isLoading: false,
      errorlist: newerrorlist
    })

  }
  // public catchNok(response: Response) {
  //   this.setState({
  //     bans: [],
  //     isLoading: false,
  //     isError: true,
  //   });

  // }

  public state: {
    isLoading: boolean,
    errorlist: (string | undefined)[],
    bans: BAN[]
  }

  constructor(props: {
    bans: BAN[], btnDropright: boolean[], actions: {
      customerbillsActions: AnyAction;
    }
  }) {
    super(props);
    this.state = {
      isLoading: false,
      errorlist: [],
      bans: this.props.bans,
    };
  }

  componentWillUnmount() {
    clearInterval(interval);
  }

  componentDidMount() {
    //if (!$.fn.DataTable.isDataTable("#table")) {
    $(document).ready(function () {
      setTimeout(function () {
        $("#table").DataTable({
        });
      }, 1000);
    });
    // }
  }

  showTable = () => {



    try {
      return SortBAN(this.state.bans).map((value, index) => {
        return (
          <tr key={"dt1" + index}>
            <td className="text-nowrap">
              <Dropdown
                direction="right"
                onClick={() => this.getBill(value.ban, (value.bills && value.bills.length === 0), index)}
                isOpen={this.props.btnDropright[index]}
                style={{ maxWidth: "200px" }}
                toggle={() => {
                  this.props.actions.customerbillsActions.requestSETDropRight(
                    index,
                    !this.props.btnDropright[index],
                    () => {
                      this.forceUpdate();
                    }
                  );
                }}
              >
                <DropdownToggle caret>{value.ban}</DropdownToggle>

                <MediaQuery minWidth={1224}>

                  <DropdownMenu

                    // @ts-ignore
                    modifiers={{
                      // @ts-ignore
                      setMaxHeight: {
                        enabled: true,
                        order: 890,
                        // @ts-ignore
                        fn: (data) => {
                          return {
                            ...data,
                            styles: {
                              ...data.styles,
                              position: "relative",
                              overflow: 'auto',
                              maxHeight: 400,
                              width: "900px"
                            },
                          };
                        },
                      },
                    }}>
                    {value.bills && value.bills.length === 0 && this.state.errorlist[index] === undefined &&
                      <Spinner animation="border" size="sm" />
                    }

                    {value.bills && value.bills.length === 0 && this.state.errorlist[index] &&
                      <Alert color="danger">{this.state.errorlist[index]}</Alert>
                    }
                    <div className="showcase-container">
                      {value.bills && value.bills.map((value, index) => {
                        return (
                          <div className="showcase-item" key={"Bills" + index}>
                            <Badge className="customBadge">
                              <NavLink href={value.pdfurl} target="_blank" style={{ padding: "0px", margin: "0px", fontSize: "18px", color: "black" }}>
                                <Button outline color="secondary" style={{ padding: "2px", margin: "0px", fontSize: "18px" }}>
                                  <div style={{ padding: "0px", margin: "0px", fontSize: "18px"}}>
                                    {value.cdt.substring(5, 7) +
                                      "/20" +
                                      value.cdt.substring(2, 4)}
                                    {fileAlt}
                                  </div>
                                </Button>
                              </NavLink>
                            </Badge>
                          </div>
                        );
                      })}
                    </div>
                  </DropdownMenu>
                </MediaQuery>
                <MediaQuery maxWidth={1224}>

                  <DropdownMenu

                    // @ts-ignore
                    modifiers={{
                      // @ts-ignore
                      setMaxHeight: {
                        enabled: true,
                        order: 890,
                        // @ts-ignore
                        fn: (data) => {
                          return {
                            ...data,
                            styles: {
                              ...data.styles,
                              position: "relative",
                              overflow: 'auto',
                              maxHeight: 400,
                            },
                          };
                        },
                      },
                    }}>
                    {value.bills && value.bills.length === 0 && this.state.errorlist[index] === undefined &&
                      <Spinner animation="border" size="sm" />
                    }

                    {value.bills && value.bills.length === 0 && this.state.errorlist[index] &&
                      <Alert color="danger">{this.state.errorlist[index]}</Alert>
                    }
                    <div className="showcase-container">
                      {value.bills && value.bills.map((value, index) => {
                        return (
                          <div className="showcase-item" key={"Bills" + index}>
                            <Badge className="customBadge">
                              <NavLink href={value.pdfurl} target="_blank" style={{ padding: "0px", margin: "0px" }}>
                                <h4 style={{ padding: "0px", margin: "0px", fontSize: "28px" }}>
                                  {value.cdt.substring(5, 7) +
                                    "/" +
                                    value.cdt.substring(2, 4)}
                                  {fileAlt}
                                </h4>
                              </NavLink>
                            </Badge>
                          </div>
                        );
                      })}
                    </div>
                  </DropdownMenu>
                </MediaQuery>
              </Dropdown>
            </td>
            <td></td>
          </tr>
        );
      });
    } catch (e) {
      //alert(e);
    }
  };

  render() {
    return (
      <div className="container-fluid py-4">
        <div className="table-responsive p-0 pb-2">
          <table
            id="table"
            className="table align-items-center justify-content-center mb-0"
          // style={{maxWidth: "800px"}}
          >
            <thead>
              <tr>
                <th className="sticky-top text-nowrap">BAN</th>
                <th className="sticky-top text-nowrap">Invoice Month / Year</th>
              </tr>
            </thead>

            <tbody>{this.showTable()}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default BillingSearchGrid;


